import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rowsPerPage: {},
  pageNumber: {},
};

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    addRowsPerPage: (state, action) => {
      const { name, data } = action.payload;
      state.rowsPerPage[name] = data;
    },
    addPageNumber: (state, action) => {
      const { name, data } = action.payload;
      state.pageNumber[name] = data;
    },
    clearTableState: (state, action) => {
      const { name } = action.payload;
      if (!name) return;
      delete state.rowsPerPage[name];
      delete state.pageNumber[name];
    },
    resetAllTableState: (state) => {
      state.rowsPerPage = {};
      state.pageNumber = {};
    },
  },
});

export default tableSlice;
export const {
  addRowsPerPage,
  addPageNumber,
  clearTableState,
  resetAllTableState,
} = tableSlice.actions;
